import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Drugi Edo",
  "description": "",
  "published": "2007-06-11T00:00:00.000Z",
  "redirect_from": ["/blog/drugi-edo/swizec/189"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Edvard Drugi je stara zares stara igra, ki jo je napisal Christopher Marlowe v elizabetinskih Äasih zgodnje moderne anglešÄine, korzetov in umazanije, veliko umazanije. Imela je Å¾e veliko reinterpretacij, eno od njih v ljubljanski Drami.`}</p>
    <p>{`Niti sanja se mi ne kako dolgo je Å¾e v repertoarju, vendar sem jo šel gledat prejšnji petek. Zastonj. Ja, prijazni gospodje in gospe gledališÄa so talali po dve karte za eno od štirih predstav vsem lastnikom abonmajskih vstopnic. Eden takih sem bil tudi sam in tako sem izbral Edvarda Drugega, ker mi je bila od vse izbire najmanj poznana.`}</p>
    <p>{`Drama je bila, nepresenetljivo, nabito polna s samo dvema meni znanima praznima sedeÅ¾ema v, na sreÄo, taki poziciji, da sem lahko prestavil svojo rit v iskanju boljšega pogleda. Res bi bilo treba nekaj storiti glede vidljivosti v tej stoletni hiši ... Kakorkoli, predstava je bila razumsko dolga in zanimiv ogled. Igralci so spektakularno uprizorili tako staro predstavo in celo pomanjkanje scenografije je dodalo pridihu elizabetinskega dvorišÄa. ObÄutek je bil pravi, Äeprav je bilo prviÄ videti zadnjo steno odra malÄek dolgoÄasno.`}</p>
    <p>{`Ko je glavni igralec, Škof, slekel vsa oblaÄila, je bilo vse skupaj nekako presenetljivo, saj se kaj takega nedvomno v pravem Äasovnem obdobju ne bi na odru nikoli zgodilo. Ko pa so ga zaÄeli stresati krÄi in je njegova oprema letala naokoli je stvar skoraj prestopila v polje grozljivke. Ampak kaj Ämo, tako je paÄ moderno gledališÄe, nagota povsod.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      